import { render, staticRenderFns } from "./ReviewActualActivity.vue?vue&type=template&id=2ab2c720&scoped=true&"
import script from "./ReviewActualActivity.vue?vue&type=script&lang=js&"
export * from "./ReviewActualActivity.vue?vue&type=script&lang=js&"
import style0 from "../SalesForce.scss?vue&type=style&index=0&id=2ab2c720&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ab2c720",
  null
  
)

export default component.exports